import styled, { css } from 'styled-components';
/**
 * The CSS is from https://inclusive-components.design/tooltips-toggletips/
 */
export const disableScrollStyles = () => css `
	position: absolute;
	height: 1px;
	width: 1px;
	overflow: hidden;
	clip-path: inset(100%);
	clip: rect(1px, 1px, 1px, 1px);
	white-space: nowrap;
`;
export const StyledDisableScroll = styled.span `
	${disableScrollStyles}
`;
